import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import LayoutTable from "./layout/Table";
import { useGlobalContext } from "../../../App";
import { getAllCategories } from "../../../services/category";
import { ButtonPrimary } from "../../../shared/components/button/Buttons";
import { PlusIconSvg } from "../../../assets/icons/PlusIconSvg";
import Search from "../../../shared/components/Search";
import AddTypographyPopup from "./component/AddTypographyPopup";
import { getAllTypographies } from "../../../services/typography";

type Props = {};

export interface ActionMenuProps {
  title: string;
  action: () => void;
  actionTitle: string;
}

const tableRef = React.createRef<any>();

const TypographyList = (props: Props) => {
  const { setAddCategoryPopup, addCategoryPopup } = useGlobalContext();
  const columnItems = [
    { id: "Name", label: "Name" },
    { id: "Link", label: "Link" },
  ];

  const [loading, setLoading] = useState(true);
  const [typographyList, setTypographyList] = useState<any>([]);
  const [search, setSearch] = useState("");

  const handleCloseAddCategoryPopup = () => {
    setAddCategoryPopup(!addCategoryPopup);
  };

  const fetchTypographies = async (filters?: any) => {
    setLoading(true);
    await getAllTypographies(filters)
      .then((res: any) => {
        setLoading(false);
        setTypographyList(res);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const filteredTypographies = search
    ? typographyList?.paginatedConstantValues?.filter((category: any) =>
        category.value.toLowerCase().includes(search.toLowerCase())
      ) || []
    : typographyList?.paginatedConstantValues || [];

  useEffect(() => {
    fetchTypographies({ type: "TYPOGRAPHY" });
  }, []);

  useEffect(() => {}, [typographyList]);

  const handleRefreshData = () => {
    fetchTypographies({ type: "TYPOGRAPHY" });
  };
  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          paddingY: "24px",
        }}
      >
        <Box
          sx={{
            position: "fixed",
            top: "15px",
            right: "98px",
            zIndex: 10000,
          }}
          display="flex"
          alignItems="center"
          justifySelf="flex-end"
        >
          <ButtonPrimary
            sx={{
              height: "45px !important",
              border: "14px !important",
              width: "112px",
            }}
            onClick={() => {
              setAddCategoryPopup(true);
            }}
            LabelStyle={{ fontSize: "18px !important" }}
            label="Add"
            endIcon={<PlusIconSvg />}
          />
        </Box>

        {/* Search input  */}
        <Box sx={{ width: "85%", mb: "16px" }}>
          <Box sx={{ width: "100%", height: "76px" }}>
            <Search
              style={{
                height: "76px",
                color: "white",
                backgroundColor: "#1A1A1A",
                paddingLeft: "40px",
                boxShadow: "none",
                borderRadius: "14px",
                fontSize: "18px",
                fontWeight: "500",
              }}
              placeholder="Search typographies"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Box>
        </Box>

        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "absolute",
              right: 0,
              left: 0,
              bottom: 0,
              top: 120,
              height: "100%",
            }}
          >
            <CircularProgress
              size={24}
              sx={{
                color: "white",
                marginRight: "12px",
              }}
            />
          </Box>
        ) : typographyList?.paginatedConstantValues?.length > 0 ? (
          <>
            <Box
              sx={{
                width: "100%",
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                <Box
                  sx={{
                    width: "85%",
                  }}
                >
                  <LayoutTable
                    loading={loading}
                    // rows={screenCategoriesList?.paginatedConstantValues}
                    rows={filteredTypographies || []}
                    columns={columnItems}
                    handleRefreshData={handleRefreshData}
                  />
                </Box>
              </Box>
            </Box>
          </>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "60vh",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white" }} variant="h5">
              No Typography to display
            </Typography>
          </Box>
        )}
      </Box>
      {/* ------------Add collections Form----------- */}
      {addCategoryPopup && (
        <AddTypographyPopup
          activeDialog={addCategoryPopup}
          handleDialog={handleCloseAddCategoryPopup}
          handleRefreshData={handleRefreshData}
        />
      )}
    </>
  );
};

export default TypographyList;
